/**
 * Copyright 2025 Design Barn Inc.
 */

import React from 'react';

export default function OutlookIcon(): React.ReactElement {
  return (
    <div className="flex items-center justify-center ">
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_7548_23060)">
          <path
            d="M10.4034 3.39257V6.52228L11.4983 7.21086C11.5378 7.21955 11.5788 7.21955 11.6183 7.21086L16.3257 4.03714C16.3223 3.88311 16.2659 3.73496 16.1661 3.61758C16.0663 3.5002 15.9292 3.42075 15.7777 3.39257H10.4034Z"
            fill="#0072C6"
          />
          <path
            d="M10.4034 7.68971L11.4017 8.37543C11.4485 8.40389 11.5021 8.41895 11.5569 8.41895C11.6116 8.41895 11.6653 8.40389 11.712 8.37543C11.5406 8.47886 16.3251 5.30229 16.3251 5.30229V11.0543C16.3376 11.1708 16.3245 11.2887 16.2866 11.3997C16.2488 11.5106 16.1872 11.6119 16.1061 11.6966C16.025 11.7812 15.9264 11.8471 15.8171 11.8897C15.7079 11.9322 15.5907 11.9503 15.4737 11.9429H10.4029L10.4034 7.68971Z"
            fill="#0072C6"
          />
          <path
            d="M5.23543 6.24686C5.06956 6.24606 4.90657 6.29015 4.76371 6.37445C4.62086 6.45875 4.50348 6.58013 4.424 6.72571C4.20692 7.11164 4.10277 7.55084 4.12343 7.99314C4.10087 8.43453 4.20517 8.87315 4.424 9.25714C4.50315 9.39674 4.61764 9.51304 4.75598 9.59437C4.89431 9.6757 5.05162 9.71919 5.21209 9.72046C5.37255 9.72174 5.53053 9.68075 5.67014 9.60163C5.80975 9.52251 5.92608 9.40804 6.00743 9.26971C6.22388 8.88749 6.32602 8.45115 6.30171 8.01257C6.3265 7.56022 6.22774 7.10965 6.016 6.70914C5.94033 6.5683 5.82764 6.4508 5.69007 6.36933C5.55251 6.28786 5.3953 6.24551 5.23543 6.24686Z"
            fill="#0072C6"
          />
          <path
            d="M0.5 1.80286V14.0469L9.81429 16V0L0.5 1.80286ZM6.73314 9.99486C6.5589 10.2405 6.32722 10.4398 6.0583 10.5753C5.78938 10.7109 5.49138 10.7786 5.19029 10.7726C4.89677 10.7778 4.60634 10.712 4.34369 10.5809C4.08104 10.4498 3.85394 10.2572 3.68171 10.0194C3.27325 9.44915 3.06892 8.75785 3.10171 8.05714C3.06697 7.32208 3.27499 6.596 3.69371 5.99086C3.87015 5.74053 4.10547 5.53746 4.37891 5.39954C4.65236 5.26162 4.95554 5.1931 5.26171 5.2C5.5531 5.19415 5.84148 5.25992 6.10151 5.39154C6.36155 5.52315 6.58531 5.71658 6.75314 5.95486C7.15752 6.53751 7.35838 7.23729 7.32457 7.94571C7.3602 8.67546 7.15214 9.39633 6.73314 9.99486Z"
            fill="#0072C6"
          />
        </g>
        <defs>
          <clipPath id="clip0_7548_23060">
            <rect width="16" height="16" fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
